import { PublicQuestion } from "@/queries/types";
import { DSTextAnswer as SystemTextAnswer } from "@hundred5/design-system";
import { useLingui } from "@lingui/react/macro";
import { Dispatch } from "react";
import * as amplitude from "../../../../amplitude";
import { withDisabledPaste } from "../../../../utils";
import { Action, State } from "../../reducer";
import DebouncedAnswer from "./debounced-answer";

interface Props {
  question: PublicQuestion;
  dispatch: Dispatch<Action>;
  state: State;
  isAnswerPasteDisabled: boolean;
}

const SystemTextAnswerWithDisabledPaste = withDisabledPaste(SystemTextAnswer);

export function TextAnswer({
  state,
  dispatch,
  question,
  isAnswerPasteDisabled,
}: Props) {
  const { t } = useLingui();
  const answer = state.answers[question.test_question_id];

  const WrappedSystemTextAnswer = isAnswerPasteDisabled
    ? SystemTextAnswerWithDisabledPaste
    : SystemTextAnswer;

  return (
    <DebouncedAnswer
      answer={answer?.freeTextAnswer || ""}
      onChange={(content) => {
        dispatch({
          type: "enter_text_answer",
          payload: {
            questionId: question.test_question_id.toString(),
            freeTextAnswer: content,
          },
        });

        amplitude.trackQuestionAnswer(
          state.jobOpeningSlug,
          state.activeQuestionIndex,
        );
      }}
    >
      {({ answer, onChange, onBlur }) => (
        <WrappedSystemTextAnswer
          value={answer}
          placeholder={t`Write answer here...`}
          disabled={state.submitting}
          onChange={(event) => {
            onChange(event.target.value);
          }}
          onBlur={onBlur}
        />
      )}
    </DebouncedAnswer>
  );
}
